import { ApiTable } from "@/shared/api/table/api-table";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

type TableSubscriptionType = "free" | "paid" | "disabled";

interface PollTableStatusOptions {
  retries?: number;
  interval?: number;
  isReady?: (subscriptionType: TableSubscriptionType) => boolean;
}

const defaultIsReady = (subscriptionType: TableSubscriptionType) =>
  subscriptionType === "paid" || subscriptionType === "free";

export const pollTableStatus = async (
  tableId: string,
  options: PollTableStatusOptions = {},
) => {
  const { retries = 20, interval = 3000, isReady = defaultIsReady } = options;
  const tableApi = new ApiTable();

  for (let i = 0; i < retries; i++) {
    try {
      const response = await tableApi.getTableStatus(tableId);
      const statusData = response.data;

      if (isReady(statusData.subscription_type)) {
        return statusData;
      }

      if (i < retries - 1) {
        await delay(interval);
      }
    } catch (error) {
      console.error(
        `Попытка опроса ${i + 1} для таблицы ${tableId} не удалась:`,
        error,
      );
      if (i < retries - 1) {
        await delay(interval);
      }
    }
  }

  throw new Error(
    `Статус таблицы ${tableId} не стал активным после ${retries} попыток.`,
  );
};
